import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from './services/auth.service';
import { FireService } from './services/fire.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    title? = 'bi-viz';
    projectId: string;
    queryData? = 'test';
    isDevMode = environment.production === false;
    signedIn$ = this.auth.signedIn$;

    constructor(
        private fire: FireService,
        private auth: AuthService,
        private router: Router
    ) {
        this.projectId = fire.app.options.projectId!;
    }

    ngOnInit(): void {}

    public get isSignedIn() {
        return this.auth.isSignedIn;
    }

    public async signIn() {
        const user = await this.auth.singIn().catch((e) => console.error(e));
        this.title = user?.user.uid;
    }

    public async signOut() {
        await this.auth.signOut().catch((e) => console.error(e));
        this.router.navigate(['/login'], { replaceUrl: true });
    }
}
